interface UploadButtonProps {
  /** The hover/aria label, e.g. "Upload a hotkey file" or "Upload a keyboard". */
  title: string;
  onClick: () => void;
}

/**
 * The icon-only upload button (design v2 `.ctl-up`): sits inside a control's `.ctl-select`,
 * right after the picker it feeds - one beside the Profile (hotkey files), one beside the
 * Keyboard (KLE / VIA / QMK). Replaces the old top-bar Import button so the upload lives
 * next to what it changes.
 */
export function UploadButton({ title, onClick }: UploadButtonProps) {
  return (
    <button type="button" className="ctl-up" title={title} aria-label={title} onClick={onClick}>
      <svg
        aria-hidden="true"
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 15V4M8 8l4-4 4 4" />
        <path d="M4 15v3a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-3" />
      </svg>
    </button>
  );
}
